//@ts-ignore
import SCSS from './../../styles/settings/responsive.scss';

export type ResponsiveScreen = (
  'xxsmall' | 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge' | 'xxlarge'
);

export const RESPONSIVE_DEFINITIONS = SCSS as {[key:string]:string};
export const RESPONSIVE_SIZES = Object.entries(RESPONSIVE_DEFINITIONS)
  .reduce((x,y) => {
    const [ key, value ] = y;
    x[key] = parseInt(value);
    return x;
  }, {} as {[key:string]:number})
;

export type ResponsiveOptions = keyof typeof RESPONSIVE_SIZES;

export const responsiveMediaAbove = (definition:ResponsiveScreen) => {
  return window.innerWidth >= RESPONSIVE_SIZES[definition] || 0;
}

export const responsiveQueryAbove = (definition:ResponsiveScreen) => {
  return `(min-width: ${RESPONSIVE_SIZES[definition]}px)`
}

export const responsiveMediaBelow = (definition:ResponsiveScreen) => {
  const entries = Object.entries(RESPONSIVE_SIZES);
  const index = entries.findIndex(entry => entry[0] === definition);
  if(index === -1) return false;
  if(index == entries.length-1) return true;
  return window.innerWidth < entries[index + 1][1];
}